import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import type { DeepReadonly } from "@/types";

type NavDropdownItem = {
  label: string;
  href: string;
};

type NavDropdownProps = DeepReadonly<{
  items: NavDropdownItem[];
  onItemClick?: () => void;
}>;

export const NavDropdown: React.FC<NavDropdownProps> = ({
  items,
  onItemClick,
}) => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const { pathname } = useLocation();

  const activeHref =
    hoveredItem ?? items.find((item) => item.href === pathname)?.href ?? null;

  return (
    <div
      className="rounded-[8px] bg-white shadow-[0px_4px_7px_rgba(0,0,0,0.10)]"
      onMouseLeave={() => setHoveredItem(null)}
    >
      <div className="p-2">
        {items.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            onClick={onItemClick}
            onMouseEnter={() => setHoveredItem(item.href)}
            className={`body-b-regular block rounded-[8px] px-6 py-4 whitespace-nowrap transition-colors ${
              activeHref === item.href
                ? "text-primary-500 bg-neutral-100"
                : "text-neutral-800"
            }`}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </div>
  );
};
